module.exports = __webpack_public_path__ + "static/media/plus.9d1f4e95.svg";